<script>
export default {
    name: 'LabelCW',
    props: {
        label: {
            type: String,
            required: true
        }
    }
}
</script>

<template>
    <div class="Label">
        {{label}}
    </div>
</template>

<style lang="scss" scoped>
@import "@/styles/variables/index";

.Label {
    margin-top: 12px;
    font-size: 16px;
    position: relative;
}
</style>
